import Vue from 'vue'
import { MutationTree } from 'vuex'
import { counterTypes } from './types'
import {CounterState} from './state';

export const counterMutations: MutationTree<CounterState> = {
  [counterTypes.mutations.updateFeatureFlags](state: CounterState, featureFlags) {
    Vue.set(state, counterTypes.state.featureFlags, featureFlags);
  },

  [counterTypes.mutations.updateSites](state: CounterState, sites) {
    Vue.set(state, counterTypes.state.sites, sites);
  },

  [counterTypes.mutations.updateSponsors](state: CounterState, sponsors) {
    Vue.set(state, counterTypes.state.sponsors, sponsors);
  },

  [counterTypes.mutations.updatePrograms](state: CounterState, programs) {
    programs.forEach(p => p.disabled = !p.isActive);
    Vue.set(state, counterTypes.state.programs, programs);
  },

  [counterTypes.mutations.updateSiteAppDates](state: CounterState, siteAppDates) {
    Vue.set(state, counterTypes.state.siteAppDates, siteAppDates);
  },

  [counterTypes.mutations.updateSiteAppNonCongregateMeals](state: CounterState, siteAppNonCongregateMeals) {
    Vue.set(state, counterTypes.state.siteAppNonCongregateMeals, siteAppNonCongregateMeals);
  },

  [counterTypes.mutations.updatePwaInstalled](state: CounterState, pwaInstalled) {
    Vue.set(state, counterTypes.state.pwaInstalled, pwaInstalled);
  },

  [counterTypes.mutations.updateIsOnline](state: CounterState, isOnline) {
    state.isOnline = isOnline;
  },

  [counterTypes.mutations.updateIsSyncing](state: CounterState, isSyncing) {
    state.isSyncing = isSyncing;
  },

  [counterTypes.mutations.updateSelectedSponsorId](state: CounterState, selectedSponsorId) {
    Vue.set(state, counterTypes.state.selectedSponsorId, selectedSponsorId);
  },

  [counterTypes.mutations.updateSelectedSiteId](state: CounterState, selectedSiteId) {
    Vue.set(state, counterTypes.state.selectedSiteId, selectedSiteId);
  },

  [counterTypes.mutations.updateSelectedProgramId](state: CounterState, selectedProgramId) {
    Vue.set(state, counterTypes.state.selectedProgramId, selectedProgramId);
  },

  [counterTypes.mutations.updateSelectedMealDate](state: CounterState, selectedMealDate) {
    Vue.set(state, counterTypes.state.selectedMealDate, selectedMealDate);
  },

  [counterTypes.mutations.updateTimeStamp](state: CounterState, timeStamp) {
    Vue.set(state, counterTypes.state.timeStamp, timeStamp);
  }
};
